import { type ComponentProps, useEffect, useRef } from 'react';

import Link from '~/src/common/components/Link';

import * as S from './layout';

type Props = ComponentProps<typeof S.Entry> & {
  href?: string;
  isActive?: boolean;
  isExpanded?: boolean;
};

const MenuEntry = ({ href, isActive, isExpanded, children, ...rest }: Props) => {
  // Scroll automatique si élément actif
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    const item = ref.current;
    const wrap = item?.parentElement;
    if (item == null || wrap == null || !isActive) return;
    // Idéalement, on devrait utiliser `scrollIntoView` mais il est impossible
    // de n'impacter que le scroll horizontal, ce qui cause un scroll de la page
    const itemLeft = item.offsetLeft;
    const itemWidth = item.getBoundingClientRect().width;
    const wrapWidth = wrap.getBoundingClientRect().width;
    const wrapScroll = itemLeft + itemWidth / 2 - wrapWidth / 2;
    wrap.scrollTo({ left: wrapScroll, behavior: 'auto' });
  }, [isActive]);

  // Props pour activation et transformation en lien
  const extra = {
    'aria-current': isActive,
    'aria-expanded': isExpanded,
    ...(href && { as: Link, href }),
  };

  return (
    <S.Entry ref={ref} {...rest} {...extra}>
      {children}
    </S.Entry>
  );
};

export default MenuEntry;
